var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTourismLeftImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 122,
    viewBox: "0 0 216 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.7607 127.019L116.901 35.6595C116.981 35.5495 117.071 35.4395 117.161 35.3395C120.051 32.2995 124.981 32.4995 127.611 35.7995L204.001 129.839",
    fill: "#99E9F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.360352 133.29L71.9104 23.7297C75.8304 18.0497 84.1303 17.9097 88.2504 23.3697C88.3704 23.5297 88.4804 23.7097 88.5804 23.8897L147.84 134",
    fill: "#C5F6FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.09 44.7001C210.049 44.7001 214.88 39.8693 214.88 33.9101C214.88 27.951 210.049 23.1201 204.09 23.1201C198.131 23.1201 193.3 27.951 193.3 33.9101C193.3 39.8693 198.131 44.7001 204.09 44.7001Z",
    fill: "#0C8599"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.31 43.2099C210.269 43.2099 215.1 38.379 215.1 32.4199C215.1 26.4607 210.269 21.6299 204.31 21.6299C198.35 21.6299 193.52 26.4607 193.52 32.4199C193.52 38.379 198.35 43.2099 204.31 43.2099Z",
    fill: "#C5F6FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.22 35.8004C204.79 37.2004 208.81 35.4404 210.21 31.8604",
    stroke: "#3BC9DB",
    strokeWidth: 0.82,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.529 30.7697C199.899 30.7697 200.199 30.4697 200.199 30.0997C200.199 29.7297 199.899 29.4297 199.529 29.4297C199.159 29.4297 198.859 29.7297 198.859 30.0997C198.859 30.4697 199.159 30.7697 199.529 30.7697Z",
    fill: "#3BC9DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.21 27.0597C207.58 27.0597 207.88 26.7598 207.88 26.3897C207.88 26.0197 207.58 25.7197 207.21 25.7197C206.84 25.7197 206.54 26.0197 206.54 26.3897C206.54 26.7598 206.84 27.0597 207.21 27.0597Z",
    fill: "#3BC9DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9165 79.6946L47.6553 83.3096L51.2703 89.5708L57.5315 85.9558L53.9165 79.6946Z",
    fill: "#22B8CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6587 77.2454L80.2881 75.9248L78.9675 79.2954L82.3381 80.616L83.6587 77.2454Z",
    stroke: "#3BC9DB",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5034 87.4007L25.874 86.0801L24.5534 82.7095L21.1829 84.0301L22.5034 87.4007Z",
    stroke: "#3BC9DB",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3804 46.9996L10.8604 43.8096L10.3604 49.3196L15.3804 46.9996Z",
    stroke: "#3BC9DB",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.68 25.2597C109.98 25.1697 110.25 24.9597 110.41 24.6697L111.93 21.8597C112.25 21.2597 112.03 20.5097 111.43 20.1897C110.83 19.8697 110.08 20.0897 109.76 20.6897L108.24 23.4997C107.92 24.0997 108.14 24.8497 108.74 25.1697C109.04 25.3197 109.38 25.3497 109.68 25.2597Z",
    fill: "#22B8CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.45 36.3098C29.13 36.3098 28.82 36.1898 28.58 35.9498L26.32 33.6898C25.84 33.2098 25.84 32.4298 26.32 31.9498C26.8 31.4698 27.58 31.4698 28.06 31.9498L30.32 34.2098C30.8 34.6898 30.8 35.4698 30.32 35.9498C30.08 36.1898 29.76 36.3098 29.45 36.3098Z",
    stroke: "#3BC9DB",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.46 62.0098C42.1283 62.0098 42.67 61.4681 42.67 60.7999C42.67 60.1316 42.1283 59.5898 41.46 59.5898C40.7917 59.5898 40.25 60.1316 40.25 60.7999C40.25 61.4681 40.7917 62.0098 41.46 62.0098Z",
    stroke: "#3BC9DB",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.43 76.5303L5.20996 81.8803",
    stroke: "#3BC9DB",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.76 52.0197C177.05 50.4097 177.88 48.4997 178.52 46.5397C179.99 42.0497 180.46 37.1097 179.06 32.5897C177.65 28.0697 174.18 24.0697 169.63 22.7697C165.08 21.4597 159.62 23.3197 157.39 27.4997C156.1 29.9297 155.96 32.8397 156.52 35.5297C156.8 36.8597 157.26 38.1897 158.12 39.2397C160.81 42.5597 166.54 41.7397 169.34 38.5097C172.14 35.2797 172.59 30.6297 172.16 26.3797C171.77 22.5397 170.62 18.5397 167.74 15.9597C166.26 14.6297 164.41 13.7797 162.52 13.1397C158.35 11.7397 153.73 11.3797 149.58 12.8297C145.79 14.1497 142.49 17.1497 141.25 20.9297",
    stroke: "#3BC9DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.21 18.5596L141.36 20.6696L143.47 19.5196L143.06 20.8996L140.95 22.0396L139.81 19.9396L140.21 18.5596Z",
    fill: "#3BC9DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.22 78.1104V66.9004H179.77V78.1104L176.59 84.0604L185.21 78.4004H195.67",
    stroke: "#3BC9DB",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5597 3.5C20.7397 3.5 15.2197 9.02 15.2197 15.84",
    stroke: "#3BC9DB",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.46 50.7803C64.6397 50.7803 70.46 44.96 70.46 37.7803C70.46 30.6006 64.6397 24.7803 57.46 24.7803C50.2803 24.7803 44.46 30.6006 44.46 37.7803C44.46 44.96 50.2803 50.7803 57.46 50.7803Z",
    fill: "#0C8599"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9697 49.04C65.1494 49.04 70.9697 43.2197 70.9697 36.04C70.9697 28.8603 65.1494 23.04 57.9697 23.04C50.79 23.04 44.9697 28.8603 44.9697 36.04C44.9697 43.2197 50.79 49.04 57.9697 49.04Z",
    fill: "#99E9F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7002 39.5402C57.7202 41.8302 62.8202 40.4302 65.1102 36.4102",
    stroke: "#3BC9DB",
    strokeWidth: 0.8038,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6801 33.2499C53.1275 33.2499 53.4901 32.8872 53.4901 32.4399C53.4901 31.9925 53.1275 31.6299 52.6801 31.6299C52.2328 31.6299 51.8701 31.9925 51.8701 32.4399C51.8701 32.8872 52.2328 33.2499 52.6801 33.2499Z",
    fill: "#3BC9DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4799 30.1698C62.9273 30.1698 63.2899 29.8072 63.2899 29.3598C63.2899 28.9125 62.9273 28.5498 62.4799 28.5498C62.0326 28.5498 61.6699 28.9125 61.6699 29.3598C61.6699 29.8072 62.0326 30.1698 62.4799 30.1698Z",
    fill: "#3BC9DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6299 28.6299L51.5699 30.5399L54.8099 29.1999L53.8999 32.5899L56.1799 35.2599L52.6799 35.4499L50.8399 38.4399L49.5799 35.1599L46.1699 34.3399L48.8999 32.1299L48.6299 28.6299Z",
    fill: "#3BC9DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.29 26.7902L60.66 25.8202L61.77 22.4902L63.73 25.4002L67.24 25.4202L65.09 28.1902L66.15 31.5402L62.85 30.3402L59.99 32.3802L60.11 28.8802L57.29 26.7902Z",
    fill: "#3BC9DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.0397 8.92008C90.0497 8.79008 90.0597 8.65008 90.0597 8.52008C90.0597 3.86008 86.2797 0.0800781 81.6197 0.0800781C76.9597 0.0800781 73.1797 3.86008 73.1797 8.52008C73.1797 8.66008 73.1897 8.79008 73.1997 8.92008H73.1797L73.1997 8.97008C72.9797 13.7401 81.6197 27.3701 81.6197 27.3701C81.6197 27.3701 90.0397 12.1401 90.0397 8.97008L90.0597 8.92008H90.0397Z",
    fill: "#66D9E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6193 13.7502C84.7286 13.7502 87.2493 11.2296 87.2493 8.12024C87.2493 5.01087 84.7286 2.49023 81.6193 2.49023C78.5099 2.49023 75.9893 5.01087 75.9893 8.12024C75.9893 11.2296 78.5099 13.7502 81.6193 13.7502Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1104 67.6396L27.7804 71.6597",
    stroke: "#3BC9DB",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTourismLeftImage);
export default __webpack_public_path__ + "static/media/tourismLeftImage.e8c09519ab58955c6aa7c954c060bb74.svg";
export { ForwardRef as ReactComponent };